<template>
  <BaseSidebarDrawer v-model="localModelValue" width="408" overlay rounded-left>
    <div class="w-full h-full relative">
      <div class="flex items-center gap-3 sticky top-0 !text-blue-dark-500 bg-white border-b px-5 py-[18px] md:!p-6">
        <BaseIcon icon="arrow-forward" class="cursor-pointer" @click="localModelValue = false" />
        <span class="font-bold text-sm">جا‌به‌جایی بین حساب‌های کاربری</span>
      </div>
      <div class="overflow-y-auto no-scrollbar overscroll-none">
        <div class="pt-6 pb-8 px-5 md:px-6 border-b">
          <div class="flex items-center gap-2.5 text-blue-dark-500">
            <div class="w-6 h-6 grid place-items-center text-sm rounded bg-blue-dark-50">1</div>
            <span class="text-xs hidden md:inline">ابتدا از نوار بالای سایت، نشان پروفایل را انتخاب کنید.</span>
            <span class="text-xs inline md:hidden">ابتدا از نوار پایین، گزینه بیشتر را انتخاب کنید.</span>
          </div>
          <img src="~@/assets/images/support/switch-between-accounts-1.webp" class="w-full h-[206px] hidden md:block object-contain mt-4" />
          <img src="~@/assets/images/support/mobile-more-menu.webp" class="w-full h-[245px] block md:hidden object-cover border rounded-lg mt-4" />
        </div>
        <div class="pt-6 pb-8 px-5 md:px-6 border-b">
          <div class="flex items-center gap-2.5 text-blue-dark-500">
            <div class="w-6 h-6 grid place-items-center text-sm rounded bg-blue-dark-50">2</div>
            <span class="text-xs hidden md:inline">گزینه «حساب‌های کاربری» را انتخاب نمایید.</span>
            <span class="text-xs inline md:hidden flex-shrink-0">آیکون مقابل نام خود را مطابق تصویر زیر انتخاب کنید.</span>
          </div>
          <img src="~@/assets/images/support/switch-between-accounts-2.webp" class="w-full h-[206px] hidden md:block object-contain mt-4" />
          <img
            src="~@/assets/images/support/mobile-switch-between-accounts-1.webp"
            class="w-full h-[245px] block md:hidden object-cover border rounded-lg mt-4"
          />
        </div>
        <div class="pt-6 pb-8 px-5 md:px-6 border-b">
          <div class="flex gap-2.5 text-blue-dark-500">
            <div class="w-6 h-6 flex-shrink-0 grid place-items-center text-sm rounded bg-blue-dark-50">3</div>
            <span class="text-xs leading-5 hidden md:inline">
              حساب مورد نظر خود را از میان حساب‌های حقیقی یا حقوقی انتخاب نمایید و روی دکمه ورود کلیک کنید.
            </span>
            <span class="text-xs leading-5 inline md:hidden">حساب مورد نظر خود را از میان حساب‌های حقیقی یا حقوقی انتخاب نمایید.</span>
          </div>
          <img src="~@/assets/images/support/switch-between-accounts-3.webp" class="w-full h-[206px] hidden md:block object-contain mt-4" />
          <img
            src="~@/assets/images/support/mobile-switch-between-accounts-2.webp"
            class="w-full h-[245px] block md:hidden object-cover border rounded-lg mt-4"
          />
        </div>
      </div>
    </div>
  </BaseSidebarDrawer>
</template>

<script setup lang="ts">
import BaseSidebarDrawer from "@/components/base/BaseSidebarDrawer.vue";
import { computed } from "vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue"]);

const localModelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>

<style scoped></style>
